module.exports = __webpack_public_path__ + "static/img/banner-bg.3f8b06e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-bg.jpg
// module id = tTqm
// module chunks = 1